package com.shadowings.gero.data.lessons.chapter2
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili
import gero.composeapp.generated.resources.exp_content_vocab_umani_scriba
import gero.composeapp.generated.resources.exp_title_vocabolario_umani

val humanNames = listOf(
    "UOMO",
    "DONNA",
    "PADRE",
    "MADRE",
    "RE DELL'ALTO EGITTO",
    "SCRIBA",
    "PASTORE",
    "SACERDOTE",
    "INFERMIERA",
    "MEDICO",
    "BALIA"
)

fun getVocabHumansContent(words: List<Word>, languageCode: String): List<IExplanation> {
    return buildVocabContent(
        lessonTitle = Res.string.exp_title_vocabolario_umani,
        lessonIntro = Res.string.exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili,
        wordIds = humanNames,
        words = words,
        languageCode = languageCode
    )
}

// Inscription photo (image code, word id, caption).
private val humanInscriptions = listOf(
    Triple("scribe", "SCRIBA", Res.string.exp_content_vocab_umani_scriba),
)

fun getVocabHumansQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode
    )
    val inscriptionQuizzes = humanInscriptions.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + inscriptionQuizzes).shuffled()
}
